const PS_CONSOLE_REALM_MAP: Record<string, string> = {
    naamazon: 'na',
    feamazon: 'fe',
    euamazon: 'eu',
    'eu-south-2': 'eu',
    cnamazon: 'cn',
};

export const getPsConsoleHost = (stage: string, realm: string): string => {
    const consoleRealm = PS_CONSOLE_REALM_MAP[realm.toLowerCase()] || 'na';
    const normalizedStage = stage.toLowerCase();
    const domain = normalizedStage === 'prod' ? 'aka.amazon.com' : 'integ.amazon.com';

    return `paystation-console-${consoleRealm}.${domain}`;
};

export const getPsConsoleRefundUrl = (stage: string, realm: string, refundId: string): string => (
    `https://${getPsConsoleHost(stage, realm)}/ps?api=refunds&refundId=${encodeURIComponent(refundId)}`
);
